import { detect } from "detect-browser";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { MaintenanceNoticeModal } from "../../components/modals/MaintenanceNoticeModal";
import { useQuery } from "../../hooks/useQuery";

export const MaintenancePreScreen = () => {
  const query = useQuery();
  const [start, setStart] = useState<moment.Moment>();
  const [end, setEnd] = useState<moment.Moment>();

  useEffect(() => {
    if (query.has("start")) {
      setStart(moment.utc(query.get("start")));
    }
    if (query.has("end")) {
      setEnd(moment.utc(query.get("end")));
    }
  }, [query]);

  const handleClose = useCallback(() => {
    const browser = detect();
    if (browser?.name === "ios-webview") {
      //@ts-ignore
      return webkit.messageHandlers.back.postMessage({});
    }
    //@ts-ignore
    if (
      browser?.name === "chromium-webview" &&
      //@ts-ignore
      window.Webviewer?.back
    ) {
      //@ts-ignore
      return window.Webviewer.back();
    }
  }, []);

  const handleRemindClose = useCallback(() => {
    const browser = detect();
    if (browser?.name === "ios-webview") {
      //@ts-ignore
      return webkit.messageHandlers.doNotRemind.postMessage({});
    }
    //@ts-ignore
    if (
      browser?.name === "chromium-webview" &&
      //@ts-ignore
      window.Webviewer?.doNotRemind
    ) {
      //@ts-ignore
      return window.Webviewer.doNotRemind();
    }
  }, []);

  const handleOpenLink = useCallback(() => {
    const browser = detect();
    if (browser?.name === "ios-webview") {
      //@ts-ignore
      return webkit.messageHandlers.openLink.postMessage({});
    }
    //@ts-ignore
    if (
      browser?.name === "chromium-webview" &&
      //@ts-ignore
      window.Webviewer?.openLink
    ) {
      //@ts-ignore
      return window.Webviewer.openLink();
    }
  }, []);

  return start && end ? (
    <MaintenanceNoticeModal
      open={true}
      start={start}
      end={end}
      onClose={handleClose}
      onRemindClose={handleRemindClose}
      close={false}
      app
      onOpenLink={handleOpenLink}
    />
  ) : (
    <></>
  );
};
